import AuthService from '../../service';
const LandingPage = {
  getLandingPage(page,search,sort_start,sort_end){
    return AuthService.get(`landing_page?`+
      `page=${page}` +
      `&sort_start=${sort_start}` +
      `&search=${search}`
    );
  },
  showLandingPage(id){
    return AuthService.get(`landing_page/${id}`);
  },
  createLandingPage(data){
    return AuthService.post(`landing_page`,data);

  },
  updateLandingPage(id,data){
    return AuthService.put(`landing_page/${id}`,data);

  },
  deleteLandingPage(id){
    return AuthService.delete(`landing_page/${id}`);

  },
}
export default LandingPage
